module.exports = __webpack_public_path__ + "img/comment 1@2x.0afb65dd.png";